var modules_997b7aad = {"container":"_1157uaz","important":"_13hiysv","text-wrapper":"_1xmnsir"};
import "../../../assets/CZPonxxD.css";

export { modules_997b7aad as default };
//# sourceMappingURL=Logo.module.less.js.map
